import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
export function UitkFieldMessage({
  className,
  message,
  id,
  type
}) {
  const cssClassNames = classNames(
    `uitk-field-message`,
    `uitk-field-message-${type}`,
    `uitk-${type}-message`,
    className
  );
  return /* @__PURE__ */ React.createElement("div", { className: cssClassNames, id: `${id}-${type}` }, message);
}
;
